export function concatStrings(separator = ', ', ...args: string[]) {
  return args.filter(arg => arg !== undefined).join(separator);
}